// extracted by mini-css-extract-plugin
export default {"link":"_03e8TM2","categoryText":"tBGgwKnH","altHeadline":"hAveppSm","headline":"AANvFAm9","_altHeadline":"c1qnh791"};